import Config from '../Config';
import Util from '../Util';
import ProfileImg from '../ProfileImg';
import GameInfo from '../GameInfo';
import Site from '../Site';
import User from '../User';
import Template from 'js-template-string';
import DateFormat from 'date-format-simple';
import StorageComment from './StorageComment';
import Svg from '../Svg';
const dateFormat = new DateFormat(
  Config.now,
  {
    a_few_seconds_ago: Config.L10N.a_few_seconds_ago,
    seconds_ago: Config.L10N.seconds_ago,
    a_minute_ago: Config.L10N.a_minute_ago,
    minutes_ago: Config.L10N.minutes_ago,
    an_hour_ago: Config.L10N.an_hour_ago,
    hours_ago: Config.L10N.hours_ago,
    a_day_ago: Config.L10N.a_day_ago,
    days_ago: Config.L10N.days_ago,
    a_month_ago: Config.L10N.a_month_ago,
    months_ago: Config.L10N.months_ago,
    a_year_ago: Config.L10N.a_year_ago,
    years_ago: Config.L10N.years_ago
  },
  true
);

const setWriterInfo = (url = '', gameCharName = '', info = '') => {
  return Config.isMyProfile ? `${Util.setWrapLink(url, gameCharName)}${info}` : gameCharName + info;
};

const setWriterImage = (url = '', profileImg = '') => {
  const image = Util.setWrapImage(profileImg);
  return Config.isMyProfile ? Util.setWrapLink(url, image) : image;
};

const numberWithCommas = x => {
  if (!x) return 0;
  let parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

const _Template = {
  listTop: () => {
    const _top = Template.render({
      data: '',
      template: data => `
        <div class="board-top-utils">
        <div id="wrapSearch" class="wrap-search"></div>
        <div class="board-btngroup">
          ${
            (Config.isCardView && Config.isThumbView) || (Config.isListView && Config.isCardView)
              ? `<div class="wrap-btn-type">
            <button class="btn-type-selected" aria-label="타입선택"></button>
            <span class="btn-type-list">
            ${Config.isListView ? `<button class="co-btn btn-list" aria-label="목록형">${Svg.getIcon('list')}</button>` : ``}
            ${Config.isThumbView ? `<button class="co-btn btn-list" aria-label="썸네일형">${Svg.getIcon('list')}</button>` : ``}
            ${Config.isCardView ? `<button class="co-btn btn-cards" aria-label="카드형">${Svg.getIcon('card')}</button>` : ``}
            </span>
          </div>`
              : ``
          }
          <span class="list-count-area"></span>
          ${Config.isShowReload ? `<button class="co-btn btn-reload"  aria-label="새로고침">${Svg.getIcon('reload')}</button>` : ``}
          ${
            Config.isWrite
              ? `<button class="co-btn co-btn-round btn-write" aria-label="${Config.L10N.btn_write}">${Svg.getIcon('write')}<span>${Config.L10N.btn_write}</span></button>`
              : ``
          }
        </div>
        </div>`
    });

    return _top;
  },

  noticeList: (_data, _categoryId = '') => {
    return Template.iterate({
      data: _data,
      template: data => {
        const dataNotice;
        const dataArticle;

        if (Config.isUuid) {
          dataNotice  = data.frontNotice.notice;
          dataArticle = data.frontArticle.article.contentMeta;
        } else {
          dataNotice  = data.notice || data.frontNotice;
          dataArticle = data.article || data.frontArticle;
        }

        const writer = dataArticle.writer;
        const loginUser = writer.loginUser;
        const gameUser = writer.gameUser;
        const characterName = gameUser.gameCharacterName || loginUser.name;
        const urlPath = (dataNotice.category && dataNotice.category.urlPath) ? dataNotice.category.urlPath : '' ;
        const boardAlias = (Config.isUuid) ? dataArticle.rootBoard.board.boardAlias : dataArticle.boardAlias;
        const articleId = (Config.isUuid) ? dataArticle.id : dataArticle.articleId;
        const emoticonUrl = (Config.isUuid) ? dataArticle.emoticonUrl : dataArticle.writer.emoticonUrl;
        const label = (Config.isUuid) ? dataNotice.contentTopNotice.label : dataNotice.label;
        let _postDate = (Config.isUuid) ? Util.toISOString(new Date(dataNotice.contentTopNotice.dateTime.publishedAt)) : dataNotice.publishDate;

        let param = `&isNotice=1`;
        if (_categoryId && urlPath.indexOf('categoryId') !== -1) {
          param = `${param}&categoryId=${_categoryId}`;
        }

        const _url = `${Config.prefixPath}/board/${boardAlias}/${Config.viewPage}?articleId=${articleId}${param}`;

        // let serverName ='';
        let _server = '';

        if ( Util.and(Config.isUserInfoWithServer, Config.serverName, gameUser, gameUser.gameServerId ) ) {
          if (GameInfo.getSite() === 'bns') {
            if( gameUser.gameCode === Config.bnsServerType.LIVE ) {
              _server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName.LIVE[gameUser.gameServerId])}</span>`;
            } else if ( gameUser.gameCode === Config.bnsServerType.FRONTIER ) {
              _server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName.FRONTIER[gameUser.gameServerId])}</span>`;
            }
          } else {
            _server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName[gameUser.gameServerId])}</span>`;
          }
        }

        return `<div class="board-notice-item">
        ${label ? `<span class="category">${label}</span>` : ``}
        <a href="${_url}">${dataArticle.title}</a>
        ${Util.diffDate(dateFormat.toGMTDate(_postDate), dateFormat.getNow()) <= 3600000 * 24 ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
        <div class="info">
        ${emoticonUrl
            ? `<span class="writer"><img src="${emoticonUrl}" alt=""/></span>`
            : `<span class="writer user">${characterName}${_server ? _server : ``}</span>`
        }
        </div>
        </div>`;
      }
    });
  },

  getNew: (_date, markup = `<i class="fe-icon-new" data-diff=""></i>`) => {
    if (!_date) {
      return '';
    }

    return Util.diffDate(dateFormat.toGMTDate(_date), dateFormat.getNow()) <= 3600000 * 24 ? markup : ``;
  },

  getDateFormat: _date => {
    return dateFormat.printUntil(_date, 'day', true);
  },

  listContainer: (_id, _type = 'default') => {
    return `<ul class="${_id} board-list-${_type}"></ul>`;
  },

  thumbList: (_data, _id, param = '') => {
    dateFormat.setDateFormat('YY.MM.DD.');
    return Template.iterate({
      data: _data.articleList,
      template: articleList => {
        const usr = User.setUser(articleList, param);
        const raceName = Site.race(articleList);
        const isServerMaster = Site.isServerMaster(articleList);
        const postDate = usr._postDate;
        const emoticonUrl = usr._emoticonUrl;

        return `<li class="board-items" data-articleid="${usr.articleId}" ${isServerMaster ? `data-is-master="true"` : ``}>
        <div class="thumb">
        ${usr.thumbnailUrl ? `<a href="${usr._url}"><img src="${usr.thumbnailUrl}" alt=""></a>` : ''}
        </div>
        <div class="title">
          ${Config.isShowListCategory ? `<span class="category">${usr.categoryName}</span>` : ``}
          <a href="${usr._url}">${usr.title}</a>
          ${usr.hasThumbnail ? Svg.getIcon('picture') : ``}
          ${usr.hasVote ? Svg.getIcon('vote') : ``}
          <div class="count" data-articleid="${usr.articleId}">
          ${
            Config.isLike
              ? `<span class="count-like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Svg.getIcon('like')}<em>${
                  usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                }</em></span>`
              : ``
          }
          <span class="count-comment" data-count="${usr.commentCount}">${Svg.getIcon('comment')}<em>${numberWithCommas(usr.commentCount)}</em></span>
        </div>
        ${Util.diffDate(dateFormat.toGMTDate(postDate), dateFormat.getNow()) <= 3600000 * 24 ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
        </div>
        <div class="info">
            ${usr._adminUser && emoticonUrl
                ? `<span class="writer writer-admin"><img src="${emoticonUrl}" alt=""/></span>`
                : `<span class="writer">${usr.writerInfo + usr._server + raceName}</span>`
            }
            <span class="date">${dateFormat.printUntil(postDate, 'day', true)}</span>
            <span class="hit"><em class="txt">${Config.L10N.hit}</em>${numberWithCommas(usr.hitCount)}</span>
            ${Config.isLike
                ? `<span class="like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Config.L10N.recommend}<em>${
                    usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                  }</em></span>`
                : ``
            }
        </div>
        ${Config.isHideCommentToList
            ? ``
            : `<div class="comment">
            <a href="${usr._url}#${Config.COMMENT_ANCHOR_NAME}" data-count="${usr.commentCount}">
                <span>
                    <em class="number"> ${usr.commentCount < 999 ? usr.commentCount : `999+`}</em>
                    <em class="txt">${Config.L10N.comment}</em>
                </span>
            </a>
        </div>`
        }
        </li>`;
      }
    });
  },

  cardList: (_data, _id, param = '') => {
    dateFormat.setDateFormat('YY.MM.DD.');
    return Template.iterate({
      data: _data.articleList,
      template: articleList => {
        const usr = User.setUser(articleList, param);
        const runningTime = Site.runningTime(articleList);
        const isSeverMaster = Site.isServerMaster(articleList);
        const postDate = usr._postDate;
        const emoticonUrl = usr._emoticonUrl;

        usr.thumbnailUrl = GameInfo.thumbnailUrl(usr.thumbnailUrl);

        return `<li class="board-items" data-articleid="${usr.articleId}"
          data-is-summary="${usr.summary.length > 0 ? true : false}"
          ${isSeverMaster ? `data-is-master="true"`: ``}>
          ${usr.thumbnailUrl ? `<div class="board-items-thumb"><a href="${usr._url}"><img src="${usr.thumbnailUrl}" alt="">${runningTime}</a></div>` : ``}
             <div class="board-items-contents">
          <div class="title">
          ${Config.isShowListCategory ? `<span class="category">${usr.categoryName}</span>` : ``}
          <a href="${usr._url}">
          ${usr.title}
          ${usr.hasVote ? Svg.getIcon('vote') : ``}
          ${Util.diffDate(dateFormat.toGMTDate(postDate), dateFormat.getNow()) <= 3600000 * 24 ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
          </a>
          </div>
          <div class="desc ${usr.thumbnailUrl ? '' : 'desc-overflow'}">
            <a href="${usr._url}">
            ${usr.summary ? usr.summary.replace(/\n/g, `<br/>`) : ''}
            ${usr.searchSummary ? usr.searchSummary.replace(/\n/g, `<br/>`) : ''}
            </a>
          </div>
          ${usr._adminUser && emoticonUrl
              ? `<div class="writer writer-admin"><img src="${emoticonUrl}" alt=""/></div>`
              : `<div class="writer">${usr.writerInfo + usr._server}</div>`
          }
          </div>
          <div class="board-items-footer">
            <div class="info">
              ${usr._adminUser && emoticonUrl
                  ? `<span class="writer writer-admin"><img src="${emoticonUrl}" alt=""/></span>`
                  : `<span class="writer">${usr.writerInfo}</span>`
              }
                <span class="date">${dateFormat.printUntil(postDate, 'day', true) || Config.L10N.a_few_seconds_ago}</span>
                <span class="hit-count" data-count="${usr.hitCount >= 0 ? usr.hitCount : 0}">
                  <span class="txt">${Config.L10N.hit} </span><em>${usr.hitCount >= 0 ? numberWithCommas(usr.hitCount) : 0}</em>
                </span>
                ${Config.isLike
                    ? `<span class="like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Config.L10N.recommend}<em>${
                        usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                      }</em></span>`
                    : ``
                }
              </div>
              <div class="count" data-articleid="${usr.articleId}" >
                ${Config.isListShare
                    ? `<button class="co-btn co-btn-share" aria-label="공유하기" data-location="${usr._url}" data-title="${usr.summary}"><i class="fe-icon-share"></i></button>`
                    : ``
                }
                ${Config.isLike
                    ? `<span class="count-like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">
                  ${Svg.getIcon('like')}<em>${usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0}</em>
                </span>`
                    : ``
                }
                ${Config.isHideCommentToList
                    ? ``
                    : `<span class="count-comment" data-count="${usr.commentCount}">
                  ${Svg.getIcon('comment')}<em>${numberWithCommas(usr.commentCount)}</em>
                </span>`
                }
              </div>
            </div>
          </div>
          </li>`;
      }
    });
  },

  list: (_data, _id, param = '') => {
    dateFormat.setDateFormat('YY.MM.DD.');
    const storageData = StorageComment.get();

    return Template.iterate({
      data: _data.articleList,
      template: articleList => {
        const usr = User.setUser(articleList, param);
        const raceName = Site.race(articleList);
        const postDate = usr._postDate;
        const emoticonUrl = usr._emoticonUrl;
        const isServerMaster = Site.isServerMaster(articleList);

        //bnsAPP app characterName
        if (Config.isBnsApp && usr._gameUser && usr._gameUser.gameCharacterName) {
          const inlineStyle = `style="text-decoration:none;color:#8c919a;"`;
          usr.writerInfo = `<a href="${Config.app.popup}http://${Util.net('.')}a.bns.plaync.com/world/character/character?cn=${usr._gameUser.gameCharacterName}" ${inlineStyle}>${
            usr._gameUser.gameCharacterName
          }</a>`;
        }

        return `<li class="board-items ${Config.isHideCommentToList ? `is-hide-comment` : ``}" 
            data-articleid="${(!!usr.scrapId) ? 
              usr.scrapId : (!!usr.previousArticleId) ?
                usr.previousArticleId :  usr.articleId}" ${isServerMaster ? `data-is-master="true"`: ``}>
          <div class="title">
            ${Config.isShowListCategory ? `<span class="category">${usr.categoryName}</span>` : ``}
            <a href="${usr._url}">${usr.title}</a>
            ${usr.hasThumbnail ? Svg.getIcon('picture') : ``}
            ${usr.hasVote ? Svg.getIcon('vote') : ``}
            <div class="count" data-articleid="${usr.articleId}">
              ${
                Config.isListShare
                  ? `<button class="co-btn co-btn-share" aria-label="공유하기" data-location="${usr._url}" data-title="${usr.summary}">${Svg.getIcon('share')}</button>`
                  : ``
              }
              ${
                Config.isLike
                  ? `<span class="count-like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Svg.getIcon('like')}<em>${
                      usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                    }</em></span>`
                  : ``
              }
              ${
                Config.isHideCommentToList
                  ? ``
                  : `<span class="count-comment" data-count="${usr.commentCount}">${Svg.getIcon('comment')}<em>${numberWithCommas(usr.commentCount)}</em></span>`
              }
            </div>
            ${Util.diffDate(dateFormat.toGMTDate(postDate), dateFormat.getNow()) <= 3600000 * 24 ? `<i class="fe-icon-new" data-diff=""></i>` : ``}
          </div>
          <div class="info">
            ${usr._adminUser && emoticonUrl
                ? `<span class="writer writer-admin"><img src="${emoticonUrl}" alt=""/></span>`
                : `<span class="writer">${usr.writerInfo + usr._server + raceName}</span>`
            }
            <span class="date">${dateFormat.printUntil(postDate, 'day', true) || Config.L10N.a_few_seconds_ago}</span>
            <span class="hit"><em class="txt">${Config.L10N.hit}</em>${numberWithCommas(usr.hitCount)}</span>
            ${Config.isLike
                ? `<span class="like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Config.L10N.recommend}<em>${
                    usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                  }</em></span>`
                : ``
            }
            ${(Config.isArticleDelete && usr.isMyArticle) || Config.isBookmarkDelete
                ? `<button class="co-btn delete" data-articleid="${usr.articleId}" data-alias="${usr.boardAlias}" aria-label="${Config.L10N.btn_delete}">${Config.L10N.btn_delete}</button>`
                : ``
            }
          </div>
          ${Config.isHideCommentToList
              ? ``
              : `<div class="comment">
            <a href="${usr._url}#${Config.COMMENT_ANCHOR_NAME}" data-count="${usr.commentCount}">
              <span ${storageData && storageData[usr.articleId] < usr.commentCount ? `class="is-new-comment"` : ``}>
                <em class="number">${usr.commentCount < 999 ? usr.commentCount : `999+`}</em>
                <em class="txt">${Config.L10N.comment}</em>
              </span>
            </a>
          </div>`
          }
        </li>`;
      }
    });
  },

  searchList: (_data, _id, param = '') => {
    dateFormat.setDateFormat('YY.MM.DD.');
    return Template.iterate({
      data: _data.articleList,
      template: articleList => {
        const usr = User.setUser(articleList, param);
        const raceName = Site.race(articleList);
        const isServerMaster = Site.isServerMaster(articleList)
        const postDate = usr._postDate;
        const emoticonUrl = usr._emoticonUrl;

        return `<li class="board-items ${usr.hasThumbnail ? `board-items-thumb` : ``}" data-articleid="${usr.articleId}" ${isServerMaster ? `data-is-master="true"`: ``}>
        <div class="search-content">
          ${usr.hasThumbnail ? `<div class="thumb"><img src="${usr.thumbnailUrl}" alt=""></div>` : ``}
          <div class="title">
              ${Config.isShowListCategory ? `<span class="category">${usr.categoryName}</span>` : ``}
              <a href="${usr._url}">${usr.title}</a>
              ${usr.hasVote ? Svg.getIcon('vote') : ``}
          </div>
          ${usr.searchSummary ? `<div class="desc"><a href="${usr._url}">${usr.searchSummary}</a></div>` : ``}
        </div>
        <div class="search-info">
          <span class="writer">${usr._adminUser && emoticonUrl ? `<img src="${emoticonUrl}" alt=""/>` : usr.writerInfo + usr._server + raceName}</span>
          <span class="date">${dateFormat.printUntil(postDate, 'day', true) || Config.L10N.a_few_seconds_ago}</span>
          <span class="hit"><em class="txt">${Config.L10N.hit}</em>${numberWithCommas(usr.hitCount)}</span>
          ${
            Config.isLike
              ? `<span class="count-like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Svg.getIcon('like')}<span class="text">${Config.L10N.recommend}</span><em>${
                  usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                }</em></span>`
              : ``
          }
          ${
            Config.isHideCommentToList
              ? ``
              : `<span class="count-comment" data-count="${usr.commentCount}">${Svg.getIcon('comment')}<em>${numberWithCommas(usr.commentCount)}</em></span>`
          }
        </div>
      </li>`;
      }
    });
  },

  searchListTagContainer: _id => {
    return `<ul class="${_id} board-list-search"></ul>`;
  },

  searchListTagItems: (_data, param = '') => {
    dateFormat.setDateFormat('YY.MM.DD.');
    const _userTags = function(_data) {
      let _arr = [];
      _data.forEach(value => {
        let _encodeTag = encodeURIComponent(value);
        _arr.push(`<a href="${Config.tagSearchLink(_encodeTag)}" class="tags">${value}</a>`);
      });
      return _arr.join('');
    };

    const _list = Template.iterate({
      data: _data,
      template: data => {
        const usr = User.setUser(data, param);
        const _url = `/board/${data.clsf}/view?articleId=${data.articleId}&categoryId=${data.category}`;
        const _date = new Date(usr._postDate).toISOString();
        const emoticonUrl = usr._emoticonUrl;

        return `<li class="board-items ${usr.thumbnailUrl ? `board-items-thumb` : ``}" data-articleid="${usr.articleId}">
        <div class="search-content">
          ${usr.thumbnailUrl ? `<div class="thumb"><img src="${usr.thumbnailUrl}" alt=""></div>` : ``}
          <div class="title">
              ${Config.isShowListCategory ? `<span class="category">${data.categoryName}</span>` : ``}
              <a href="${_url}">${usr.title}</a>
          </div>
          ${data.content ? `<div class="desc"><a href="${_url}">${data.content}</a></div>` : ``}
        </div>
        <div class="search-tags">${_userTags(data.userTags)}</div>
        <div class="search-info">
          <span class="writer">${usr._adminUser && emoticonUrl ? `<img src="${emoticonUrl}" alt=""/>` : usr.writerInfo + usr._server}</span>
          <span class="date">${dateFormat.printUntil(_date, 'day', true) || Config.L10N.a_few_seconds_ago}</span>
          <span class="hit"><em class="txt">${Config.L10N.hit}</em>${numberWithCommas(usr.hitCount)}</span>
          ${
            Config.isLike
              ? `<span class="count-like" data-count="${usr.goodCount >= 0 ? usr.goodCount : 0}">${Svg.getIcon('like')}<span class="text">${Config.L10N.recommend}</span><em>${
                  usr.goodCount >= 0 ? numberWithCommas(usr.goodCount) : 0
                }</em></span>`
              : ``
          }
          <span class="count-comment" data-count="${usr.commentCount}">${Svg.getIcon('comment')}<em>${numberWithCommas(usr.commentCount)}</em></span>
        </div>
      </li>`;
      }
    });

    return _list;
  },

  listShare: () => {
    return `<div id="ncShare" class="nc-share"></div>`;
  },

  prevNext: _data => {
    let _next = _data.nextArticle || ``;
    let _prev = _data.previousArticle || ``;
    const _tmpNext = _next;

    if (Config.isReversePrevNext) {
      _next = _prev;
      _prev = _tmpNext;
    }

    return Template.render({
      data: { _next: _next, _prev: _prev },
      template: _v => {
        let prevContentMeta;
        let nextContentMeta;
        let prevArticleId;
        let prevCategoryId;
        let nextArticleId;
        let nextCategoryId;

        if( Config.isUuid ) {
          prevContentMeta = (_v._prev && _v._prev.article && _v._prev.article.contentMeta ) ? _v._prev.article.contentMeta : '';
          nextContentMeta = (_v._next && _v._next.article && _v._next.article.contentMeta ) ? _v._next.article.contentMeta : '';
          prevArticleId = (prevContentMeta.id) ? prevContentMeta.id : '';
          prevCategoryId = (prevContentMeta.categoryBoard && prevContentMeta.categoryBoard.id) ? prevContentMeta.categoryBoard.id : '';
          nextArticleId = (nextContentMeta.id) ? nextContentMeta.id : '';
          nextCategoryId = (nextContentMeta.categoryBoard && nextContentMeta.categoryBoard.id) ? nextContentMeta.categoryBoard.id : '';
        } else {
          prevArticleId = (_v._prev && _v._prev.articleId) ? _v._prev.articleId : '';
          prevCategoryId = (_v._prev && _v._prev.category && _v._prev.category.categoryId) ? _v._prev.category.categoryId : '';
          nextArticleId = (_v._next && _v._next.articleId) ? _v._next.articleId : '';
          nextCategoryId = (_v._next && _v._next.category && _v._next.category.categoryId) ? _v._next.category.categoryId : '';
        }

        return `
        <div class="board-nav">
        ${ (!!prevArticleId) ?
          `<p class="prev">
            <span>${Config.L10N.prev_article}</span>
            <a href="${Config.viewPage}?articleId=${prevArticleId}&categoryId=${prevCategoryId}">${_v._prev.title}</a>
          </p>` : ''
        }

        ${ (!!nextArticleId) ?
        `<p class="next">
          <span>${Config.L10N.next_article}</span>
          <a href="${Config.viewPage}?articleId=${nextArticleId}&categoryId=${nextCategoryId}">${_v._next.title}</a>
        </p>` : ''
        }
        </div>`
      }
    });
  },

  comment: _content => {
    return `<section class="wrap-comment ncCommentCommonWrap">${_content}</section>`;
  },

  setCommentUploadFrame: (frameSrc = `${window._path || '/'}html/commentUpload.html`, content) => {
    return `<iframe src="${frameSrc}" class="comment-upload comment-frame${content}" frameborder="0" scrolling="no" width="30" height="20"></iframe>`;
  },

  setCommentEmoticon: () => {
    return `<span class="co-btn btn-emoticon">${Svg.getIcon('emoticon')}</span>`;
  },

  commentWrite: (content, placeHolder = '', isUpdate = false) => {
    const isActive = Config.isLogin() ? 'is-active' : '';

    return `<div class="comment-form comment-form-${content} ${isActive}">
    <i class="fe-icon-reply"></i>
    <div class="comment-form-textarea">
    <textarea class="${content}" name="content" placeholder="${placeHolder || Config.L10N.comment_placeholder_logout}" ></textarea>
    </div>
    <div class="comment-toolbar">
    <div class="left">
    ${!isUpdate && Config.isCommentEmoticon ? `${_Template.setCommentEmoticon()}` : ``}
    ${!isUpdate && Config.isCommentUpload ? `${_Template.setCommentUploadFrame(Config.commentUploadFrame, content)}` : ``}
    </div>
    <div class="right">
    <span class="count-word"><em>0</em>/${Config.commentTextMaxCount}</span>
    <button type="button" class="co-btn btn-confirm btn-${content}" aria-label="${!isUpdate ? Config.L10N.btn_register : Config.L10N.btn_modify}">${
      !isUpdate ? Config.L10N.btn_register : Config.L10N.btn_modify
    }</button>
    </div>
    </div>
    </div>`;
  },

  commentRemove: () => {
    return `<div class="comment-article-delete">
    <div class="comment-info"></div>
    <div class="comment-contents">${Config.L10N.comment_list_delete}</div>
    <div class="comment-utils"></div>
    </div>`;
  },

  commentList: (_data, timeMsg = '') => {
    if (!_data.commentList) {
      return '';
    }

    if (GameInfo.isMine()) {
      Config.isOwnerOfArticle = true;
    }

    if (Config.isCommentArticleOwner) {
      const _articleWriter = StorageComment.getArticleWriter();
      const _articleGameuser = (_articleWriter && _articleWriter.gameUser) ? Util.setDefaultByEmptyString(_articleWriter.gameUser) : '';
      const _articleLoginUser = (_articleWriter && _articleWriter.loginUser) ? Util.setDefaultByEmptyString(_articleWriter.loginUser) : '';
    }

    return Template.iterate({
      data: _data.commentList,
      template: _v => {
        const _data = (Config.isUuid) ? _v.comment.contentMeta : _v;
        const _commentId = (Config.isUuid) ? _data.id : _data.commentId;
        const _serviceRef = (Config.isUuid) ? _data.serviceRef : '';
        const _writer = _data.writer;
        const _adminUser = _writer.admin || _writer.adminUser;
        const _gameUser = Util.setDefaultByEmptyString(_writer.gameUser);
        const _loginUser = Util.setDefaultByEmptyString(_writer.loginUser);
        const _gameCharacterId = Util.setDefaultByEmptyString(_gameUser.gameCharacterId);
        const _gameCharName = Util.setDefaultByEmptyString(_gameUser.gameCharacterName);
        const _gameServerId = Util.setDefaultByEmptyString(_gameUser.gameServerId);
        const _loginName = Util.setDefaultByEmptyString(_loginUser.name);
        const _loginUid = Util.setDefaultByEmptyString(_loginUser.uid);
        const _depth = (Config.isUuid) ? ( (!!_data.hierarchy.parent) ? 1: 0) : _data.depth;
        const _goodCount = (Config.isUuid) ? _data.reactions.likeCount : _data.goodCount;
        const _replyCount = (Config.isUuid) ? _data.reactions.replyCount : _data.replyCount;

        //my writing article
        const _isNewWrited = _data.isNewWrited;
        const emoticonUrl = Util.setDefaultByEmptyString(Config.isUuid ? _data.emoticonUrl : _writer.emoticonUrl);
        const characterUrl = Site.characterUrl(_data);
        const sandboxUrl = Site.sandboxUrl(_data);
        const raceName = Site.race(_data);

        let _contents = (Config.isUuid) ? _v.comment.content.content : _v.contents;
        let _server = '';
        let url = '';
        let writerInfo;
        let writerImg;
        let _contentType = 'text';
        let _postDate = (Config.isUuid) ? Util.toISOString( new Date(_data.timestamps.postedAt)) : _v.postDate;
        let profileImg = Util.setDefaultByEmptyString(_gameUser.profileImage);
        let isMyArticle = Util.and(Config.guid, Config.guid === _loginUser.uid);
        let _statusCode = _data.statusCode;
        // statusCode Convert
        // Normal(1),
        // Draft(2),
        // Move(3),
        // Deleted(91),
        // DeletedByAdmin(92),
        // DeletedBySystemByError(93),
        // DeletedInvisibleOnList(99),
        // Unknown(-9999);
        if (_statusCode ) {
          if ( _statusCode.toString() === 'NORMAL') {
            _statusCode = 1;
          } else if ( _statusCode.toString() === 'DELETE_USER' ) {
            _statusCode = 91;
          } else if ( _statusCode.toString() === 'DELETE_ADMIN' ) {
            _statusCode = 92;
          }
        }

        if (Util.and(!_loginUser.uid, _gameUser)) {
          isMyArticle = GameInfo.isEqualGameUser(_gameCharName, _gameServerId);
        }

        _contents = Util.replaceImage(_contents);

        //If contents type is Image
        if (_contents.indexOf('<img src') !== -1) {
          _contentType = 'image';
        }

        // if (!isNaN(_postDate)) {
        //   _postDate = new Date(_postDate);
        //   _postDate = Util.toISOString(_postDate);
        // }

        //checked server exists
        if ( Util.and(
              Config.isUserInfoWithServer,
              !!Config.serverName,
              _gameServerId)
          ) {
          if (GameInfo.getSite() === 'bns') {
            if ( _gameUser.gameCode === Config.bnsServerType.FRONTIER ) {
              _server = `<span class="server">${Util.or(Config.serverName.FRONTIER[_gameServerId], '&nbsp;')}</span>`;
            } else {
              _server = `<span class="server">${Util.or(Config.serverName.LIVE[_gameServerId], '&nbsp;')}</span>`;
            }
          } else {
            _server = `<span class="server">${Util.or(Config.serverName[_gameServerId], '&nbsp;')}</span>`;
          }
        }

        //Remove reply, if isNoReply option is true
        if (Config.isNoReply && _depth && _depth.toString() === '1') {
          return '';
        }

        //It works, if ncAccount is false and character is true
        if (Util.and(Util.or(_gameUser.gameUserUid, _gameCharacterId), _gameCharName, !Config.isNcAccount)) {
          const gameCharacterOriginId = _gameUser.gameCharacterOriginId || _gameUser.gameCharacterId;
          url = GameInfo.gameUserProfile(_gameUser.gameUserUid, _loginUser.uid, Config.guid, _gameCharName, _gameServerId, _gameUser.gameCharacterId, _gameUser.gameCode) ;
          profileImg = profileImg || ProfileImg.getCharacter(_gameUser.gameUserUid, _gameServerId, gameCharacterOriginId);
          writerInfo = setWriterInfo(url, _gameCharName, _server + raceName);
          writerImg = setWriterImage(url, profileImg);
          //writing article by me
        } else if (Util.and(!Config.isNcAccount, _gameCharName, _server && _isNewWrited)) {
          url = GameInfo.userProfile(_loginUser.uid, Config.guid);
          writerInfo = setWriterInfo(url, _gameCharName, _server + raceName);
          writerImg = setWriterImage(url, profileImg);
        } else {
          //ncAccount
          url = GameInfo.userProfile(_loginUser.uid, Config.guid);
          profileImg = profileImg || ProfileImg.getProfile(_loginUser.uid);
          writerInfo = setWriterInfo(url, Util.or(_loginName, _gameCharName));
          writerImg = setWriterImage(url, profileImg);
        }

        //It works, If bnsApp is true
        if (Util.and(Config.isBnsApp, _gameCharName)) {
          profileImg = ProfileImg.getCharacter(_gameUser.gameUserUid, _gameServerId, _gameUser.gameCharacterId);
          writerInfo =
            _loginUser.name + Util.setWrapLink(`${Config.app.popup}http://${Util.net('.')}a.bns.plaync.com/world/character/character?cn=${_gameCharName}`, `[${_gameCharName}]`);
          writerImg = ``;
        } else if (Config.isBnsApp) {
          writerInfo = `${Util.or(_loginUser.name, _gameCharName)}`;
          writerImg = ``;
        }

        //@TODO It works, If this site is bns
        if (Util.and(sandboxUrl, characterUrl, _loginName, _gameCharName)) {
          writerInfo = `${Util.setWrapLink(sandboxUrl, _loginName)}<span class="">[${Util.setWrapLink(characterUrl, _gameCharName)}]</span>`;
        }

        if (emoticonUrl && _adminUser) {
          writerInfo = Util.setWrapImage(emoticonUrl);
        }

        if (emoticonUrl && Config.board === 'devnote') {
          writerInfo = `<img src="${emoticonUrl}" alt="" style="max-height:19px;"/>`;
        }

        //lineage
        if (GameInfo.getSite() === 'lineage' || GameInfo.getSite() === 'lineage2') {
          profileImg = Config.defaultCommentProfileImage;
          profileImg = (Config.isUuid) ?
              Site.profileImg(_v.comment.content.serviceReserved.reserved1, profileImg) :
              Site.profileImg(_data.reserved1, profileImg);
          writerImg = Config.isMyProfile ? Util.setWrapLink(url, Util.setWrapImage(profileImg)) : Util.setWrapImage(profileImg);
        }

        if (GameInfo.getSite() === 'bns' && _gameUser.gameCode === Config.bnsServerType.FRONTIER) {
          writerImg = writerImg.replace('/bns/', '/bnsr/');
        }

        let commentStyle = '';
        let commentReplyStyle = '';
        let commentReplyButtonStyle = '';
        let commentThumb = `<span class="thumb">${_adminUser ? `${Util.setWrapImage(Config.adminCommentImg)}` : `${writerImg}`}</span>`;

        let articleOwner = (function() {
          if (!Config.isCommentArticleOwner || _adminUser || emoticonUrl !== '') {
            return false;
          }

          if (_gameCharName !== '' && _gameCharName === _articleGameuser.gameCharacterName && Number(_gameServerId) === Number(_articleGameuser.gameServerId)) {
            return true;
          }

          if (_loginUid !== '' && _loginUid === _articleLoginUser.uid) {
            return true;
          }

          return false;
        })();

        if (Config._isHideCommentProfile) {
          commentStyle = `style="padding-left:0;"`;
          commentReplyStyle = `style="padding-left:26px;"`;
          commentReplyButtonStyle = `style="top:20px;left:-26px;"`;
          commentThumb = '';
        }

        return `<div class=${
          (_depth && _depth.toString() === '1') ? `"comment-article-reply" ${commentReplyStyle} ` :
          (_statusCode === 1) ? `"comment-article" ${commentStyle} ` : `"comment-article-delete" ${commentStyle} `}
          data-commentid="${_commentId}">
        <div class="comment-info">
          <i class="fe-icon-reply"></i>
          ${commentThumb}
          ${articleOwner ? `<span class="writer-owner">${Config.L10N.search_searchtype_writer}</span>` : ``}
          <span class="writer">${writerInfo}</span>
          ${Config.isBnsApp
            ? `<span class="date">${Util.or(timeMsg, dateFormat._format(new Date(_postDate)))}</span>`
            : `<span class="date">${Util.or(timeMsg, dateFormat.printUntil(_postDate, 'day', true))}</span>`
        }
        ${Util.and(isMyArticle, Config.isCommentUpdate, _contentType === 'text') ?
          `<button class="co-btn btn-modify" data-commentuser="${Util.or(_gameCharName, _loginName)}"
           data-commentid="${_commentId}" data-uid="${_loginUser.uid}" data-serviceref="${_serviceRef}" aria-label="${Config.L10N.btn_modify}">
            ${Config.L10N.btn_modify}</button>
            <button class="co-btn btn-cancel" data-commentuser="${Util.or(_gameCharName, _loginName)}"
            data-commentid="${_commentId}" data-uid="${_loginUser.uid}" data-serviceref="${_serviceRef}" aria-label="${Config.L10N.btn_cancel}" style="display:none;">
            ${Config.L10N.btn_cancel}</button>`
         : ``}
        ${ isMyArticle || (Config.allowOwnerToDeleteComment && Config.isOwnerOfArticle) ? 
          `<button class="co-btn btn-delete" data-commentuser="${Util.or(_gameCharName, _loginUser.name)}"
            data-commentid="${_commentId}" data-uid="${_loginUser.uid}" aria-label="${Config.L10N.btn_delete}">
            ${Config.L10N.btn_delete}</button>`
          : ``}

        ${ Util.and(!_adminUser, !isMyArticle) ? `<button class="co-btn btn-declare"
        data-commentuser="${Util.or(_gameCharName, _loginUser.name)}"
        data-commentid="${_commentId}" data-uid="${_loginUser.uid}" aria-label="${Config.L10N.more_report}">
        ${Config.L10N.more_report}</button>`
            : ``}
        </div>
        <div class="comment-contents">${ (_statusCode > 90)  ? `${Config.L10N.comment_list_delete}` : Util.escape(_contents)}</div>
        <div class="comment-utils">
        ${Config.isLike ? `
          <button data-commentid="${_commentId}" class="co-btn co-btn-like" aria-label="좋아요수">
            ${Svg.getIcon('like')}
            <em class="text">${_goodCount >= 0 ? _goodCount : 0}</em>
          </button>`
            : ``
        }
        ${ Config.isNoReply ? `` :
          `<button class="co-btn co-btn-comments" data-commentid="${_commentId}" aria-label="댓글수">
            ${Svg.getIcon('comments')}
            <em class="text">${_replyCount}</em>
          </button>` }
        </div>
        </div>`;
      }
    });
  },

  loader: id => {
    //@TODO Template
    return `<div class="nc-community-loader"><div class="loader-circle"></div></div>`;
  },

  communityLevelName: name => {
    return `<span class="community-level-name">${name}</span>`;
  },

  viewSignature: _data => {
    const raceName = Site.race(_data);
    const _userInfo = Site.userInfo(_data);

    return Template.render({
      data: _data,
      template: (_v, _writer = _data.writer) => {
        const _loginUser = _writer.loginUser;
        const _gameUser = _writer.gameUser;
        const _url = GameInfo.userProfile(_loginUser.uid, Config.guid, _gameUser.gameCharacterName, _gameUser.gameServerId) || '#';
        const _communityLevelName = _v.communityLevelName || '';
        let _profileImg = '';
        let _userProfile = '';
        let _userName = _writer.loginUser.name;
        let communityLevelName = '';

        if (_writer.loginUser.uid) {
          _profileImg = ProfileImg.getProfile(_writer.loginUser.uid);
          _userProfile = `<img src="${_profileImg}" alt="">`;
        }

        if (Config.isMyProfile) {
          _userProfile = _profileImg ? `<a href="${_url}"><img src="${_profileImg}" alt=""></a>` : ``;
          _userName = `<a href="${_url}">${_loginUser.name || _gameUser.gameCharacterName}</a>`;
        }

        if (_communityLevelName && _communityLevelName !== '-') {
          communityLevelName = _Template.communityLevelName(_communityLevelName);
        }

        return `<div class="view-signature">
        <div class="thumb">${_userProfile}</div>
        <div class="writer">
        ${communityLevelName}
        ${_userName}
        </div>
        ${ _gameUser.gameCharacterName
            ? `<div class="info">
        ${_gameUser.gameCharacterName ? `<span class="jon">${_gameUser.gameCharacterName}</span>` : ``}
        ${_userInfo.server ? `<span class="servername">${_userInfo.server}</span>` : ``}
        ${_userInfo.guild ? `<span class="clan">${_userInfo.guild}</span>` : ``}
        ${raceName}
        </div>`
            : ``
        }
        </div>`;
      }
    });
  },

  viewSignatureApp: _data => {
    const inlineStyle = `style="text-decoration:none;color:#8c919a;"`;
    const _userInfo = Site.userInfo(_data);

    return Template.render({
      data: _data,
      template: (_v, _writer = _data.writer) => `
        <div class="view-signature">
        <div class="thumb"><img src="${ProfileImg.getProfile(_writer.loginUser.uid)}" alt=""></div>
          <div class="writer">
            <a href="${Config.app.popup}http://${Util.net('.')}sandbox.plaync.com/${_writer.loginUser.uid}" ${inlineStyle}>
            ${_writer.loginUser.name}
            </a>
          </div>
        ${
          _writer.gameUser.gameCharacterName
            ? `<div class="info">
          ${
            _writer.gameUser.gameCharacterName
              ? `<span class="jon">
          <a href="${Config.app.popup}http://${Util.net('.')}a.bns.plaync.com/world/character/character?cn=${_writer.gameUser.gameCharacterName}" ${inlineStyle}>
          ${_writer.gameUser.gameCharacterName}
          </a>
          </span>`
              : ``
          }
        </div>`
            : ``
        }
        </div>`
    });
  },

  view: (_data, isNotice) => {
    if (!Config.isLike) {
      isNotice = true;
    }

    return Template.render({
      data: _data,
      template: (_v) => {
        const _data = (Config.isUuid) ? _v.article.article.contentMeta : _v.article;
        const _writer = _data.writer;
        const _adminUser = _writer.admin || _writer.adminUser;
        const _gameUser = _writer.gameUser;
        const _loginUser = _writer.loginUser;
        const _emoticonUrl = (Config.isUuid) ? _data.emoticonUrl : _writer.emoticonUrl;
        const postDate = (Config.isUuid) ? Util.toISOString( new Date(_data.timestamps.postedAt)) : _data.postDate;
        const _postDate = dateFormat.printFull(postDate);
        const _communityLevelName = _v.communityLevelName;
        const isMobile = jQuery('body').hasClass('mobile');
        const isApp = jQuery('body').hasClass('app');
        const raceName = Site.race(_data);
        const _hitCount = (Config.isUuid) ? _data.reactions.viewCount : _data.hitCount;
        const _commentCount = (Config.isUuid) ? _data.reactions.commentCount : _data.commentCount;
        const _goodCount = (Config.isUuid) ? _data.reactions.likeCount : _data.goodCount;
        const replaceList = {
          '<': '&lt;',
          '>': '&gt;'
        };
        const _title = String(_data.title).replace(/[<>]/g, tag => {
          return replaceList[tag] || tag;
        });
        const _isScrapArticle = _v.isScrapArticle;
        let _server = '';
        let userProfile = '';
        let _contents = (Config.isUuid) ? _v.article.article.content.content : _data.contents;
        let communityLevelName = '';
        let isMyArticle = Util.and(Config.guid, Config.guid === _loginUser.uid);

        if (Util.and(!_loginUser.uid, _gameUser)) {
          //myArticle check
          isMyArticle = GameInfo.isEqualGameUser(_gameUser.gameCharacterName, _gameUser.gameServerId);
        }

        if (GameInfo.isMine()) {
          Config.isOwnerOfArticle = true;
        }

        if (Util.and(!isNotice, !Config.isAdmin, !isApp, Config.useMobileImage, !Config.isBnsApp, isMobile, Config.board !== 'cartoon')) {
          const preset = Util.or(GameInfo.isMobileSite(), GameInfo.getSite() === 'lineage') ? '$1$2_preset/mobile/' : '$1$2_mobile/';
          _contents = _contents.replace(/(<img.+?src=.+?plaync.co.+?)(download)\//g, preset);
        }

        if (Util.and(
            Config.isUserInfoWithServer,
            Config.serverName,
            _gameUser,
            _gameUser.gameServerId
          )
        ) {
          if (GameInfo.getSite() === 'bns') {
            if( _gameUser.gameCode === Config.bnsServerType.LIVE ) {
              _server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName.LIVE[_gameUser.gameServerId])}</span>`;
            } else if ( _gameUser.gameCode === Config.bnsServerType.FRONTIER ) {
              _server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName.FRONTIER[_gameUser.gameServerId])}</span>`;
            }
          } else {
            _server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName[_gameUser.gameServerId])}</span>`;
          }
        }

        if (!Config.isMyProfile) {
          //dosen't show my Profile Info
          userProfile = `${Util.or(_gameUser.gameCharacterName, _loginUser.name)}${_server}${raceName}`;
        } else {
          userProfile = `<a href="${GameInfo.userProfile(_loginUser.uid, Config.guid, _gameUser.gameCharacterName, _gameUser.gameServerId)}">
            ${Util.or(_gameUser.gameCharacterName, _loginUser.name)}</a>${_server}${raceName}`;
        }

        if (Util.and(_gameUser.gameCharacterName, Util.or(_gameUser.gameCharacterId, _gameUser.gameUserUid))) {
          //character
          if (!Config.isMyProfile) {
            userProfile = `${_gameUser.gameCharacterName}${_server}${raceName}`;
          } else {
            userProfile = `<a href="${GameInfo.gameUserProfile(
              _gameUser.gameUserUid,
              _loginUser.uid,
              Config.guid,
              _gameUser.gameCharacterName,
              _gameUser.gameServerId,
              _gameUser.gameCharacterId,
              _gameUser.gameCode
            )}">${_gameUser.gameCharacterName}</a>${_server}${raceName}`;
          }
        }

        if (Config.writerInfo) {
          const _writerContents = (articleList.reservedFields && articleList.reservedFields[Config.writerInfo] && articleList.reservedFields[Config.writerInfo].contents) ? articleList.reservedFields[Config.writerInfo].contents : ''
          userProfile = _writerContents && _writerContents.writing ? '글: ' + _writerContents.writing : '';
          userProfile = _writerContents && _writerContents.picture ? `${writerInfo} / 그림: ${_writerContents.picture}` : `${writerInfo}`;
          userProfile = _writerContents && _writerContents.illustrator ? `${writerInfo} / 일러스트: ${_writerContents.illustrator}` : `${writerInfo}`;
        }

        //ncAccount
        if (!userProfile) {
          userProfile = _loginUser.name;
        }

        if (Util.and(_communityLevelName, _communityLevelName !== '-')) {
          communityLevelName = _Template.communityLevelName(_communityLevelName);
        }

        let userButtons = '';
        let utilButtons = '';
        let likeButton = '';
        let bookmarkButton = '';
        let reportButton = '';
        let writeButton = '';

        if (!Config.isAdmin) {
          userButtons = `<li class="more-items"><button class="co-btn co-btn-modify" aria-label="${Config.L10N.more_modify}">${Config.L10N.more_modify}</button></li>
          <li clss="more-items"><button class="co-btn co-btn-delete" aria-label="${Config.L10N.more_delete}">${Config.L10N.more_delete}</button></li>`;
        }

        if (!isNotice && Config.isLike) {
          likeButton = `<button class="co-btn co-btn-like" aria-label="${Config.L10N.recommend}">
          ${Svg.getIcon('like')}
          ${Svg.getIcon('like_fill')}
          <span>${Config.L10N.recommend}</span><em>${_goodCount >= 0 ? numberWithCommas(_goodCount) : 0}</em>
          </button>`;
        }

        if (Util.and(!isMyArticle, Config.isBookmark)) {
          bookmarkButton = `<button class="co-btn co-btn-bookmark${_isScrapArticle ? ` is-active` : ``}" aria-label="${Config.L10N.more_bookmark}">
          ${Svg.getIcon('bookmark')}
          ${Svg.getIcon('bookmark_fill')}
          <span>${Config.L10N.more_bookmark}</span>
          </button>`;
        }

        if (Util.and(!isMyArticle, !_adminUser)) {
          reportButton = `<button class="co-btn co-btn-report">${Config.L10N.more_report}</button>`;
        }

        if (Util.and(!Config.isAdmin, !_adminUser)) {
          utilButtons = `<div class="wrap-util">
          <button class="co-btn co-btn-modify">${Config.L10N.more_modify}</button>
          <button class="co-btn co-btn-delete">${Config.L10N.more_delete}</button>
          ${reportButton}
          </div>`;
        }

        if (Config.isWrite) {
          writeButton = `<button class="co-btn co-btn-round co-btn-write">${Svg.getIcon('write')}<span>${Config.L10N.btn_write}</span></button>`;
        }

        const _viewHeader = `<div class="view-header" style="${Config.isHideViewInfo ? `display:none;` : ``}">
          <h2 class="view-title">${_title}</h2>
          <div class="view-info">
          <span class="writer">
            ${communityLevelName}
            ${Util.and(_adminUser, _emoticonUrl) ? `<img src="${_emoticonUrl}" alt=""/>` : `${userProfile}`}
          </span>
          
          <span class="date">${_postDate}</span>
          <span class="hit" data-count="${_hitCount}">${Config.L10N.hit}<em>${numberWithCommas(_hitCount)}</em></span>
          ${_commentCount
            ? `<span class="comment" data-count="${_commentCount}">${Config.L10N.comment}<em>${numberWithCommas(_commentCount)}</em></span>`
            : ``
          }
          </div>
        </div>`
        const _viewBody = `<div class="view-body">
          ${Util.escape(_contents)}
          <!--contents-->
        </div>`;
        const _viewUtils = `<div class="view-utils">
          ${likeButton}
          ${bookmarkButton}
          ${Config.isShare ? `<div id="ncShare" class="nc-share"></div>` : ''}
          </div>`

        const viewBottom = `${Util.or(Config.isAdmin, _adminUser, !Config.isShowSignature) ? `` : Config.isBnsApp ? _Template.viewSignatureApp(_data) : _Template.viewSignature(_data)}
        <div class="view-bottom" style="${Config.isHideViewInfo ? `display:none;` : ``}">
          <div class="left">${!Config.isShowBtnList ? `` : `<button class="co-btn co-btn-round co-btn-list"><i class="fe-icon-arrow_left"></i><span>${Config.L10N.btn_list}</span></button>`}</div>
          <div class="right">${utilButtons}${writeButton}
          </div>
        </div>`;

        return `
        <section class="board-view">
          ${_viewHeader}
          ${_viewBody}
          ${_viewUtils}
          ${viewBottom}
        </section>`;
      }
    });
  },

  vote: (data, goodCount) => {
    return `<div>
    <span>${Config.L10N.recommend}</span>
    <button id="voteButton">${Config.L10N.recommend}</button>
    <span>${data && data.voteType === 'FOR' ? `${Config.L10N.recommend}` : ''}</span>
    <span id="goodCount">${goodCount && goodCount >= 0 ? `${goodCount}` : 0}</span>
    </div>`;
  },

  scrapInfo: (scrapCount, templateId) => {
    return Template.render({
      data: scrapCount,
      template: _v => `
      <span>스크랩</span><span id="${templateId}">${_v}</span>`
    });
  },

  scrapButton: (scrapCount, templateId) => {
    return `<button id=${templateId}>${Config.L10N.more_bookmark} ${scrapCount}</button>`;
  },

  scrapDeleteButton: templateId => {
    return `<button id=${templateId}>${Config.L10N.more_bookmark} ${Config.L10N.more_delete}</button>`;
  },

  modal: (_id = 'ncCommunityReportModal') => {
    return `<div id="${_id}" class="co-layer-modal"></div>`;
  },

  report: (_id = 'ncCommunityReport', commentPrefix = '') => {
    return `
      <div id="${_id}" class="co-layer nc-community-report">
      <header class="co-layer-header">
      <h1 class="co-layer-title">${Config.L10N.report_title}</h1>
      <button class="co-btn co-btn-close ly-close">${Svg.getIcon('close')}</button>
      </header>

      <section class="co-layer-contents report-contents">
      <div class="report-remain">
      <h2>
      ${Config.L10N.report_remain}
      <span class="wrap-count"><em class="count">16</em>${Config.L10N.report_number}</span>
      </h2>
      <p class="desc">${Config.L10N.report_info}</p>
      </div>

      <div class="report-target">
      <h2>${Config.L10N.report_username}</h2>
      <strong class="target"></strong>
      </div>

      <div class="report-cause">
      <h2>${Config.L10N.report_reason}</h2>
      <ul class="list-cause" id="${commentPrefix}reportCauseList">
      <li>
      <label for="${commentPrefix}reportCase1">${Config.L10N.report_reason1}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase1" checked="checked" value="1"/>
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase2">${Config.L10N.report_reason2}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase2" value="2"/>
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase3">${Config.L10N.report_reason3}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase3" value="3" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase4">${Config.L10N.report_reason4}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase4" value="4" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase5">${Config.L10N.report_reason5}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase5" value="5" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase6">${Config.L10N.report_reason6}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase6" value="6" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase7">${Config.L10N.report_reason7}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase7" value="7" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase8">${Config.L10N.report_reason8}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase8" value="8" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase9">${Config.L10N.report_reason9}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase9" value="9" />
      ${Svg.getIcon('checked')}
      </li>
      <li>
      <label for="${commentPrefix}reportCase0">${Config.L10N.report_reason0}</label>
      <input type="radio" name="reportCase" id="${commentPrefix}reportCase0" value="0" />
      ${Svg.getIcon('checked')}
      </li>
      </ul>
      </div>
      </section>

      <footer class="co-btn-wrap report-btn-wrap">
      <button class="reportFinish co-btn co-btn-finish" aria-label="${Config.L10N.btn_finish}">${Config.L10N.btn_finish}</button>
      <button class="reportCancel co-btn co-btn-cancel ly-close" aria-label="${Config.L10N.btn_cancel}">${Config.L10N.btn_cancel}</button>
      </footer>
      </div>`;
  },

  listMsg: data => {
    return `<div class="board-list-none"><p>${Config.L10N.list_none_article}</p></div>`;
  },

  empty: (_id, _list) => {
    return Template.render({
      data: _list,
      template: list => `<ul class="${_id} board-list-none"><li>${_list}</li></ul>`
    });
  },

  emptySearch: (_id, _list, param = '') => {
    return Template.render({
      data: _list,
      template: list => `<ul class="${_id} board-list-none">
        <li>${_list}<div class="co-btn-wrap"><a href="${Config.listPage}?${param}" class="co-btn co-btn-round co-btn-list">${Config.L10N.btn_fromlist}</a>
        </div></li></ul>`
    });
  },

  emptySearchTag: (_id, _list, param = '') => {
    return Template.render({
      data: _list,
      template: list => `<li class="${_id} board-list-none">
            ${_list}
            <div class="co-btn-wrap">
                <a href="${Config.listPage}?${param}" class="co-btn co-btn-round co-btn-list">
                  ${Config.L10N.btn_fromlist}
                </a>
            </div>
        </li>`
    });
  },

  tagList: () => {
    return `<div class="wrap-tag">
      <div class="wrap-tag_surface"></div>
      <ul class="tag-list"></ul>
    </div>`;
  },

  plusTag: () => {
    return `<div class="plus-tag"><span class="btn-plus-tag">${Config.L10N.tag_recmd}</span>${Svg.getIcon('reload')}</div>`;
  },

  tagItems: (tag, isPlusTag, seq) => {
    return `<li class="tag-items ${isPlusTag ? 'is-plus' : ''}" ${seq ? `data-tag-seq="${seq}"` : ``}>
        <span class="text">${tag}</span><a class="tag-delete">${Svg.getIcon('close')}</a>
      </li>`;
  },

  tagItemsView: tag => {
    let _encodeTag = encodeURIComponent(tag);
    return `<li class="tag-items"><a href="${Config.tagSearchLink(_encodeTag)}" class="text">${tag}</a></li>`;
  },

  tagInput: data => {
    return `<div class="new-tag">
        <form id="tagAutoSuggest" class="tag-auto-suggest" method="get" action="" onsubmit="return false">
            <div class="wrap-tag-input">
              <input type="text" id="deleteTagInput" class="delete-tag-input">
              <label for="tagInput">#</label>
              <input type="text" id="tagInput" class="tag-input" value="" autocomplete="off" data-name="suggest_input" placeholder="${Config.L10N.tag_placeholder}"/>
            </div>
            <div data-name="suggest_wrap" class="suggest_wrap">
                <div data-name="suggest_list" class="suggest_list">
                    <div data-name="suggest_scroll"><ul></ul></div>
                </div>
            </div>
        </form>
        ${
          Config.usePlusTag
            ? `<div class="wrap-tag-info">
          <button class="co-btn-round co-btn-recommand is-active" aria-label="자동등록">
            <span>자동등록</span>
            <span class="recommand-toggle-on">ON</span>
            <span class="recommand-toggle-off">OFF</span>
          </button>
          <span class="tag-info">?</span>
          <div class="tag-tooltip">
            <div class="tag-tooltip-contents">
            글 등록 시 내용을 분석하여<br>
            추천태그를 자동으로 등록합니다.
          </div>
        </div>`
            : ``
        }
      </div>`;
  },

  dialog: _data => {
    let header = _data.msg.header ? _data.msg.header.replace('\n', `<br>`) : '';
    let body = _data.msg.body ? _data.msg.body.replace('\n', `<br>`) : '';

    return ` <div id="${_data.id}" class="ui-dialog">
		<div class="ui-dialog-overlay"></div>
		<div class="ui-dialog-contents">
			${_data.msg.header ? `<div class="ui-dialog-header">${header}</div>` : ``}
			${_data.msg.body ? `<div class="ui-dialog-body">${body}</div>` : ``}
			<div class="ui-dialog-footer">
				<button class="co-btn co-btn-round co-btn-ok" aria-label="확인">
                  ${_data.msg.ok ? _data.msg.ok : '확인'}
                </button>
                ${
                  _data.msg.cancel
                    ? `<button class="co-btn co-btn-round co-btn-cancel" aria-label="취소">
                    ${_data.msg.cancel}
                  </button>`
                    : ``
                }
			</div>
			<button class="btn ui-dialog-close" aria-label="닫기">
              ${Svg.getIcon('close')}
            </button>
		</div>
	</div>`;
  },

  btnCommentMore: (param = 'nc-comment-more') => {
    return `<div class="wrap-community-more">
      <button class="${param}" aria-label="${Config.L10N.btn_more}"><span class="txt">${Config.L10N.btn_more}</span></button>
    </div>`;
  },

  btnListTop: () => {
    return `<div class="wrap-btn-top">
      ${Config.L10N.btn_top}
      <button class="co-btn-top_list" aria-label="${Config.L10N.btn_top}"></button>
    </div>`;
  }
};

export default _Template;
